import { render, staticRenderFns } from "./scholarAnalysisDetails.vue?vue&type=template&id=500cfb50&scoped=true&"
import script from "./scholarAnalysisDetails.vue?vue&type=script&lang=js&"
export * from "./scholarAnalysisDetails.vue?vue&type=script&lang=js&"
import style0 from "./scholarAnalysisDetails.vue?vue&type=style&index=0&id=500cfb50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500cfb50",
  null
  
)

export default component.exports